import { supabase } from "../Db_Connections/db_connection";

export async function getAllTickets() {
    const { data, error } = await supabase
        .from("tickets")
        .select("*")
        .order("created_at", { ascending: false });

    return { data, error };
}

export async function getTicketsByAssignee(assigneeEmail) {
    // ✅ FIRST: email match (new correct data)
    const resEmail = await supabase
        .from("tickets")
        .select("*")
        .eq("assignee", assigneeEmail)
        .order("created_at", { ascending: false });

    if (resEmail.error) return { data: null, error: resEmail.error };

    // ✅ SECOND: old data support (assignee stored as full name)
    // CHANGE: profile se full name nikal rahe hain
    const { data: prof, error: profErr } = await supabase
        .from("profiles")
        .select("first_name,last_name")
        .eq("email", assigneeEmail)
        .single();

    // Agar profile nahi mili ya error aaya, at least email wale tickets return kar do
    if (profErr || !prof) return { data: resEmail.data || [], error: null };

    const fullName = `${prof.first_name || ""} ${prof.last_name || ""}`.trim();
    if (!fullName) return { data: resEmail.data || [], error: null };

    const resName = await supabase
        .from("tickets")
        .select("*")
        .eq("assignee", fullName)
        .order("created_at", { ascending: false });

    if (resName.error) {
        // name query fail ho jaye to bhi email data return
        return { data: resEmail.data || [], error: null };
    }

    // ✅ MERGE + unique by ticket_id
    const map = new Map();
    [...(resEmail.data || []), ...(resName.data || [])].forEach((t) => {
        map.set(t.ticket_id, t);
    });

    // created_at desc sort (optional)
    const merged = Array.from(map.values()).sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );

    return { data: merged, error: null };
}
export async function addTicket(payload) {
    const insertObj = {
        project_id: payload.project_id ?? null,
        title: payload.title?.trim(),
        type: payload.type || null,
        module: payload.module || null,
        assignee: payload.assignee || null, // email stored
        reporter: payload.reporter || null,
        priority: payload.priority || "Medium",

        // ✅ status is boolean now (default false)
        status: payload.status ?? false,

        story_points: payload.story_points ?? 1,
        description: payload.description || null,
        design_link: payload.design_link || null,
        acceptance_criteria: payload.acceptance_criteria || null,
        estimated_time: payload.estimated_time || null,
        file_name: payload.file_name || null,

        is_closed: false,
        closed_at: null,
    };
    

    const { data, error } = await supabase
        .from("tickets")
        .insert([insertObj])
        .select()
        .single();

    return { data, error };
}

export const updateTicket = async (ticket_id, updates) => {
    try {
        const { data, error } = await supabase
            .from("tickets")
            .update(updates)
            .eq("ticket_id", ticket_id)
            .select()
            .single();

        return { data, error };
    } catch (e) {
        return { data: null, error: e };
    }
};

// ✅ Admin toggle: false -> true / true -> false
export async function setTicketReady(ticket_id, readyBool) {
    const { data, error } = await supabase
        .from("tickets")
        .update({
            status: !!readyBool,
            updated_at: new Date().toISOString(),
        })
        .eq("ticket_id", ticket_id)
        .select()
        .single();

    return { data, error };
}

// ✅ User close: only when ready=true (we also check on UI)
export async function closeTicket(ticket_id) {
    const { data, error } = await supabase
        .from("tickets")
        .update({
            is_closed: true,
            closed_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
        })
        .eq("ticket_id", ticket_id)
        .select()
        .single();

    return { data, error };
}